var ValueTypes = {
  PERCENTAGE: "percentage",
  ABSOLUTE: "absolute"
};

module.exports = ValueTypes;



// WEBPACK FOOTER //
// ./src/js/constants/ValueTypes.js